import React from 'react'

export const TrashCanIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.33333 5.33337V12C3.33333 13.4728 4.52724 14.6667 6 14.6667H10C11.4728 14.6667 12.6667 13.4728 12.6667 12V5.33337M9.33333 7.33337V11.3334M6.66667 7.33337L6.66667 11.3334M10.6667 3.33337L9.72916 1.92711C9.48187 1.55618 9.06556 1.33337 8.61975 1.33337H7.38025C6.93444 1.33337 6.51813 1.55618 6.27084 1.92711L5.33333 3.33337M10.6667 3.33337H5.33333M10.6667 3.33337H14M5.33333 3.33337H2"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
